import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useSupportTicketActivity({
  enabled = true,
  code,
  page = 1,
}: {
  code: string;
  enabled?: boolean;
  page?: number;
}) {
  const api = useApi();

  return useQuery({
    queryKey: [`supportTicket/${code}/activity`, page], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: `supportTicket/${code}/activity`,
        params: { page },
      });
      return res;
    },
    enabled,
  });
}
